<template>
  <div class="dashboard_content">
    <div class="dashboardInformation">
      <h1 class="contentTitle gold">重要なお知らせ</h1>
      <h2 class="informationTitle" v-show="!isExistsInfomation">
        現在、重要なお知らせはありません。
      </h2>
      <h2 class="informationTitle" v-text="title" :if="isExistsInfomation"></h2>
      <div
        id="message"
        class="informationMessage"
        :if="isExistsInfomation"
        v-bind:class="{singleLine: !showMulti, multiLine: showMulti}"
        v-text="message"
      ></div>
      <div
        class="informationMessage detail_info_button"
        v-show="isExistsInfomation && !showMulti"
        v-on:click="showMulti = !showMulti"
      >
        <img class="nextArrow" :src="arrowDown" /><br />
        続きを読む
      </div>
      <div
        class="informationMessage detail_info_button"
        v-show="isExistsInfomation && showMulti"
        v-on:click="showMulti = !showMulti"
      >
        <img class="nextArrow" :src="arrowUp" /><br />
        閉じる
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    informations: Array
  },
  data() {
    return {
      showMulti: false,
      arrowDown: require('../../img/arrowDown.png'),
      arrowUp: require('../../img/arrowUp.png')
    }
  },
  computed: {
    isExistsInfomation() {
      if (this.informations == null || this.informations.length === 0) {
        return false
      } else {
        return true
      }
    },
    title() {
      if (this.isExistsInfomation) {
        return this.informations[0].title
      }
      return ''
    },
    message() {
      if (this.isExistsInfomation) {
        return this.informations[0].value
      }
      return ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/dashboardInformation.vue